module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/89f0c7bda15efdcea10aeec140348916.png";